import { render, staticRenderFns } from "./MonthlyNotRenewals.vue?vue&type=template&id=8b9e7b8a"
import script from "./MonthlyNotRenewals.vue?vue&type=script&lang=js"
export * from "./MonthlyNotRenewals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports